export const PERFIS = {
  ADMIN_NACIONAL: 'PIT.1',
  PARTICIPANTE: 'PIT.2',
  ADMIN_REGIONAL: 'PIT.3',
  // Confirmado pela equipe SNA em 2026-04-21 como código oficial do perfil Avaliador.
  AVALIADOR: 'PIT.4'
} as const;
